import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ProjectModelEndpoint } from '@rappider/rappider-sdk';

@Injectable({
  providedIn: 'root'
})
export class CodeNavigationService {
  private codeNavigationTrigger = new Subject<ProjectModelEndpoint>();
  codeNavigationTrigger$ = this.codeNavigationTrigger.asObservable();
  navigateToCode(endpoint: ProjectModelEndpoint) {
    this.codeNavigationTrigger.next(endpoint);
  }
}
